import { Box, Typography } from '@mui/material';
import React from 'react';
import TwField, { TwInputTypes } from '../../../../../components/TwFields/TwFields';
import {
  INamedCompanies,
  REQUIRED_FIELDS,
  RequiredFields
} from '../../../../../redux/api/factoring/factoring.model';
import TwCheckbox from '../../../../../components/TwCheckboxes/TwCheckboxes';

interface NamedCompaniesProps {
  company: string;
  factoringData: INamedCompanies;
  requiredFields: RequiredFields[];
  sendAllInvoices: boolean;
  handleFactoringData: (data: INamedCompanies, sendByDefault: boolean) => void;
}

const NamedCompanies: React.FC<NamedCompaniesProps> = ({
  company,
  factoringData,
  requiredFields,
  sendAllInvoices,
  handleFactoringData
}): JSX.Element => {
  return (
    <>
      <Box className="factoring__details">
        <Typography variant="subtitle2" fontWeight="600" fontSize="14px">
          How to add details
        </Typography>
        <Typography variant="subtitle2" fontWeight="400" fontSize="14px" lineHeight="24px">
          To set up your FTP integration with {company}, please reach out to your {company} rep for
          credentials. Once set up, enter those credentials here. Reach out to Truckbase support for
          further questions. We’re happy to help!
        </Typography>
      </Box>
      {requiredFields.includes(REQUIRED_FIELDS.USERNAME) && (
        <div className="tid-factoring__details__username">
          <TwField
            id="username"
            name="username"
            value={factoringData.username}
            label="Username"
            inputType={TwInputTypes.text}
            onInputChange={(e): void => {
              handleFactoringData({ ...factoringData, username: e.target.value }, sendAllInvoices);
            }}
          />
        </div>
      )}
      {requiredFields.includes(REQUIRED_FIELDS.PASSWORD) && (
        <div className="tid-factoring__details__password">
          <TwField
            id="password"
            name="password"
            value={factoringData.password}
            label="Password"
            inputType={TwInputTypes.password}
            onInputChange={(e): void => {
              handleFactoringData({ ...factoringData, password: e.target.value }, sendAllInvoices);
            }}
          />
        </div>
      )}
      {requiredFields.includes(REQUIRED_FIELDS.CLIENT_NO) && (
        <div className="tid-factoring__details__clientNo">
          <TwField
            id="clientNo"
            name="clientNo"
            value={factoringData.clientNo}
            label="Client number"
            inputType={TwInputTypes.text}
            onInputChange={(e): void => {
              handleFactoringData({ ...factoringData, clientNo: e.target.value }, sendAllInvoices);
            }}
          />
        </div>
      )}
      <TwCheckbox
        name="sendAllInvoices"
        value="sendAllInvoices"
        label="Send all invoices to factoring by default"
        checked={sendAllInvoices}
        onInputChange={(e): void => {
          handleFactoringData(factoringData, e.target.checked);
        }}
      />
    </>
  );
};

export default NamedCompanies;
